import { render, staticRenderFns } from "./ResetContest.vue?vue&type=template&id=3a86cbbc&scoped=true&"
import script from "./ResetContest.vue?vue&type=script&lang=js&"
export * from "./ResetContest.vue?vue&type=script&lang=js&"
import style0 from "./ResetContest.vue?vue&type=style&index=0&id=3a86cbbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a86cbbc",
  null
  
)

export default component.exports